import { IconWrapper } from '../runtime';
export default IconWrapper('triangle-left', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M9.97612 4.60262C10.4224 4.32371 11 4.64617 11 5.17425L11 10.8261C11 11.346 10.4377 11.6694 9.99104 11.4068C8.29358 10.4089 7.03806 9.67075 5.33181 8.66766C4.89652 8.41176 4.88772 7.78244 5.31598 7.51481L9.97612 4.60262Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});